import React, { useState } from 'react';
import { Row, Col, FormGroup, Button, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useHistory } from 'react-router-dom';

import { createNotification } from '../../services/api/api-service';

import MtSweetAlert from '../Components/MtSweetAlert';
import MtFormLayout from '../Components/MtFormLayout';

const AddNotification = () => {

    const history = useHistory();

    const [confirmMsg, setConfirmMsg] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");

    const [notificationData, setNotificationData] = useState(null);

    const goBack = () => {
        history.goBack();
    };


    // Form submit
    const handleValidSubmit = (event, values) => {

        if (!values.msgSection || !values.msgText) {

            setSubmitStatus(true);
            setAlertMsg("Please enter notification title and message");

            return;
        }

        const dataValue = {
            msgSection: values.msgSection,
            msgText: values.msgText,
            language: values.language || "English",
            date: new Date(),
            status: "read"
        };

        console.log("Notification Data:", dataValue);

        setNotificationData(dataValue);
        setConfirmMsg(true);
    };


    // Confirm and save
    const submitHandler = () => {

        if (!notificationData) {
            return;
        }

        createNotification(notificationData)
            .then((result) => {

                console.log("Notification Created:", result);

                setConfirmMsg(false);
                setSuccessMsg(true);

            })
            .catch((error) => {

                console.log("Error creating notification:", error);

                setConfirmMsg(false);
                setSubmitStatus(true);
                setAlertMsg("Something went wrong while creating notification");

            });
    };


    return (

        <React.Fragment>

            <MtFormLayout
                breadcrumbsTitle="Notification"
                breadcrumbItem="Add Notification"
                title="Add Notification"
                subTitle="Create notification for mobile app users"
            >

                <AvForm
                    className="needs-validation"
                    onValidSubmit={handleValidSubmit}
                >

                    <Row>

                        {/* Notification Title */}

                        <Col md="12">

                            <FormGroup>

                                <Label>
                                    Notification Title
                                </Label>

                                <AvField
                                    name="msgSection"
                                    placeholder="Enter notification title"
                                    type="text"
                                    errorMessage="Enter Notification Title"
                                    className="form-control"
                                    validate={{
                                        required: {
                                            value: true
                                        }
                                    }}
                                />

                            </FormGroup>

                        </Col>


                        {/* Notification Message */}

                        <Col md="12">

                            <FormGroup>

                                <Label>
                                    Notification Message
                                </Label>

                                <AvField
                                    name="msgText"
                                    placeholder="Enter notification message"
                                    type="textarea"
                                    rows="5"
                                    errorMessage="Enter Notification Message"
                                    className="form-control"
                                    validate={{
                                        required: {
                                            value: true
                                        }
                                    }}
                                />

                            </FormGroup>

                        </Col>


                        {/* Language */}

                        <Col md="6">

                            <FormGroup>

                                <Label>
                                    Language
                                </Label>

                                <AvField
                                    name="language"
                                    type="select"
                                    className="form-control"
                                >

                                    <option value="English">
                                        English
                                    </option>

                                    <option value="Hindi">
                                        Hindi
                                    </option>

                                </AvField>

                            </FormGroup>

                        </Col>


                        {submitStatus && (

                            <Col md="12">

                                <div
                                    className="alert alert-danger fade show"
                                    role="alert"
                                >
                                    {alertMsg}
                                </div>

                            </Col>

                        )}

                    </Row>


                    <Button
                        color="success"
                        type="submit"
                    >
                        Submit
                    </Button>

                </AvForm>

            </MtFormLayout>


            {/* Confirmation */}

            {confirmMsg ? (

                <MtSweetAlert
                    alertTitle="Add Notification"
                    alertConfirmBtnText="Submit"
                    alertHandler={submitHandler}
                >

                    Do You Want To Submit Notification?

                </MtSweetAlert>

            ) : null}


            {/* Success */}

            {successMsg ? (

                <MtSweetAlert
                    alertTitle="Notification"
                    alertConfirmBtnText="Go Back"
                    alertHandler={goBack}
                >

                    Notification Added Successfully

                </MtSweetAlert>

            ) : null}


        </React.Fragment>

    );
};


export default AddNotification;